import React from 'react'
import { Outlet } from 'react-router-dom'

import SellerHeader from "../components/seller/SellerHeader"

function Layout() {
  return (
    <div>
      <SellerHeader />
      <div style={{ paddingTop: "15vh" }}>
        <Outlet />
      </div>
    </div>
  )
}

export default Layout